import { h } from 'preact';

export default function Button({ variant = 'primary', size, children, ...props }) {
  const cls = `btn btn-${variant} ${size ? `btn-${size}` : ''}`;
  return <button class={cls} {...props}>{children}</button>;
}
